import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SvgIconComponent, injectRegisterIcons } from '@ngneat/svg-icon';
import { TranslatePipe } from '@ngx-translate/core';

import { appChevronRight16Icon } from '@icons/chevron-right-16';

@Component({
  selector: 'app-table-view-link',
  imports: [TranslatePipe, SvgIconComponent],
  templateUrl: './table-view-link.component.html',
  host: {
    class: 'flex items-center gap-2 text-action-primary text-sm font-semibold',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableViewLinkComponent {
  public label = input<string>();

  constructor() {
    injectRegisterIcons(appChevronRight16Icon);
  }
}
